import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoicingBill = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "1em",
	width: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_11721_91069)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M19.8153 1H21.1847C21.6662 1 22.1279 1.16389 22.4683 1.45561C22.8087 1.74733 23 2.143 23 2.55556V6.96296C23 7.238 22.8725 7.50178 22.6455 7.69626C22.4186 7.89074 22.1108 8 21.7898 8H18V2.55556C18 2.143 18.1913 1.74733 18.5317 1.45561C18.8721 1.16389 19.3338 1 19.8153 1Z",
				stroke: "var(--icon-color, currentColor)",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21 1H4.25C3.38805 1 2.5614 1.34241 1.9519 1.9519C1.34241 2.5614 1 3.38805 1 4.25V22.9375L5.83333 20.7708L9.5 22.9375L13.2519 20.7708L18 22.9375V8.3125",
				stroke: "var(--icon-color, currentColor)",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5 9.75H11.75V8C11.75 7.66848 11.6183 7.35054 11.3839 7.11612C11.1495 6.8817 10.8315 6.75 10.5 6.75H8.5C8.16848 6.75 7.85054 6.8817 7.61612 7.11612C7.3817 7.35054 7.25 7.66848 7.25 8V9.75H5.5C5.16848 9.75 4.85054 9.8817 4.61612 10.1161C4.3817 10.3505 4.25 10.6685 4.25 11V13C4.25 13.3315 4.3817 13.6495 4.61612 13.8839C4.85054 14.1183 5.16848 14.25 5.5 14.25H7.25V16C7.25 16.3315 7.3817 16.6495 7.61612 16.8839C7.85054 17.1183 8.16848 17.25 8.5 17.25H10.5C10.8315 17.25 11.1495 17.1183 11.3839 16.8839C11.6183 16.6495 11.75 16.3315 11.75 16V14.25H13.5C13.8315 14.25 14.1495 14.1183 14.3839 13.8839C14.6183 13.6495 14.75 13.3315 14.75 13V11C14.75 10.6685 14.6183 10.3505 14.3839 10.1161C14.1495 9.8817 13.8315 9.75 13.5 9.75Z",
				stroke: "var(--icon-color, currentColor)",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgInvoicingBill;
